import { createAsyncThunk } from "@reduxjs/toolkit";
import UserApiService from "../apiServices/UserApiService";
import { UserPreferences, UserProfile } from "../../interfaces/UserObject";

// Thunk to update the profile
export const profileUpdate = createAsyncThunk(
  "profile/update",
  async (profile: any, {}) => {
    const response: any = await UserApiService.updateProfile(profile);
    return response.contents[0];
  },
);

export const fetchProfile = createAsyncThunk("profile/fetch", async (_, { rejectWithValue }) => {
  const response: any = await UserApiService.getprofileById();
  if (response.contents == null || response.generalProcessingStatus.processingStatus === "ERROR") {
    return rejectWithValue(response);
  }
  return response.contents[0];
});

export const fetchOtherUserDetailsByUserId = createAsyncThunk(
  "profile/fetchOtherUserDetails",
  async ({otherUserId}: { otherUserId: string }, { rejectWithValue }) => {
    const response: any = await UserApiService.getOtherUserDetailsByUserId(otherUserId);
    if (response.contents == null || response.generalProcessingStatus.processingStatus === "ERROR") {
      return rejectWithValue(response);
    }
    return response.contents[0];
  }
);

// Deletes the authenticated user's account. The backend identifies the user
// from the Bearer token, so no argument is needed. On success the caller is
// expected to log the user out (resetAllState + redirect).
export const deleteAccount = createAsyncThunk(
  "profile/delete",
  async (_, { rejectWithValue }) => {
    const response: any = await UserApiService.deleteProfile();
    if (response?.generalProcessingStatus?.processingStatus === "ERROR") {
      return rejectWithValue(response);
    }
    return response;
  },
);

export const validateEmail = createAsyncThunk(
  "profile/validateEmail",
  async (email: string) => {
    const response: any = await UserApiService.validateEmail(email);
    return response.contents[0];
  },
);

export const updateUserPreferences = createAsyncThunk(
  "profile/updatePreferences",
  async (userPreferences: UserPreferences | any) => {
    const response: any = await UserApiService.updateUserPreferences(userPreferences);
    return response.contents[0];
  },
);

const ProfileThunk = { profileUpdate, fetchProfile, deleteAccount, validateEmail, updateUserPreferences };
export default ProfileThunk;
